import { render, staticRenderFns } from "./SearchIABoxQueryComponent.vue?vue&type=template&id=1d168ddf&scoped=true"
import script from "./SearchIABoxQueryComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchIABoxQueryComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchIABoxQueryComponent.vue?vue&type=style&index=0&id=1d168ddf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d168ddf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d168ddf')) {
      api.createRecord('1d168ddf', component.options)
    } else {
      api.reload('1d168ddf', component.options)
    }
    module.hot.accept("./SearchIABoxQueryComponent.vue?vue&type=template&id=1d168ddf&scoped=true", function () {
      api.rerender('1d168ddf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/documentSearcher/components/SearchAdvanceIA/components/SearchIaBoxQuery/SearchIABoxQueryComponent.vue"
export default component.exports